import {initDetailByAPI} from '@web/actions/detail'
import {decodeHtmlEntities as decode} from '@web/helpers/htmlEntities'
import makeSlice from '@web/slices/additionalOption/sliceMaker'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initDetailByAPI.fulfilled, (state, {payload}) => {
            const {
                data: {
                    deliveryAddress: {
                        orderAdditionalInfoParticularInput,
                        orderAdditionalInfoLists: additionalInfoList,
                        orderAdditionalInfos: additionalInfos,
                    },
                },
            } = payload

            if (orderAdditionalInfoParticularInput && additionalInfoList) {
                state.additionalInfoList = additionalInfoList.map(({productName, additionalInfos: infos}) => ({
                    productName,
                    additionalInfos: infos.map(({additionalInfoName, additionalInfoValue}) => ({
                        additionalInfoName,
                        additionalInfoValue: decode(additionalInfoValue),
                    })),
                }))
            } else if (!orderAdditionalInfoParticularInput && additionalInfos) {
                state.additionalInfoList = [{additionalInfos}].map(({additionalInfos: infos}) => ({
                    additionalInfos: infos.map(({additionalInfoName, additionalInfoValue}) => ({
                        additionalInfoName,
                        additionalInfoValue: decode(additionalInfoValue),
                    })),
                }))
            }
        })
    },
})

export default slice.reducer
